export default () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="#223455" />
    <path
      d="M16.0527 21.4224C16.0527 19.7394 17.4171 18.375 19.1001 18.375H32.8053C34.4884 18.375 35.8528 19.7394 35.8528 21.4224V24.4698L39.8766 22.1705C40.4599 21.8371 41.1857 22.2583 41.1857 22.9302V27.5172V32.1043C41.1857 32.7761 40.4599 33.1973 39.8766 32.864L35.8528 30.5646V33.612C35.8528 35.2951 34.4884 36.6594 32.8053 36.6594H19.1001C17.4171 36.6594 16.0527 35.2951 16.0527 33.612V21.4224Z"
      fill="white"
    />
  </svg>
)
